<template>
  <v-autocomplete
    v-bind="$attrs"
    item-value="id_produto"
    item-text="descricao_full"
    :items="listaDeProduto"
    v-bind:value="modelValue"
    :multiple="multiple"
    v-on="inputListeners"
    :loading="carregando_dados"
    @keyup="buscarProdutoAposDigitacao"
  >
    <template #progress>
      <v-progress-linear
        style="position: absolute"
        height="2px"
        color="red"
        indeterminate
      />
    </template>

    <template v-for="(_, slot) of $scopedSlots" #[slot]="scope">
      <slot :name="slot" v-bind="scope"/>
    </template>

    <template #prepend-inner>
      <slot name="prepend-inner" />
    </template>

    <template #selection="{item}" v-if="multiple">
      <template v-if="modelValue.indexOf(item.id_produto) === 0">
        {{ item.descricao }}
      </template>

      <template v-if="modelValue.indexOf(item.id_produto) === 1">
        <span class="ml-1 text-gray-900">(+ {{ modelValue.length - 1 }})</span>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
import ProdutoAPI from '../../../api/produto'

export default {
  name: 'SysProdutoAutocomplete',
  inheritAttrs: false,
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {type: [Array, String, Number, Object], required: true},
    grupo: {
      type: [String, Number],
      default: 1
    },
    getAposMounted: {
      type: Boolean,
      default: true
    },
    fornecedores: Array,
    forceBusca: {
      type: Array,
      default: () => []
    },
    ignorar_produtos: {
      type: Array,
      default: () => []
    },
    multiple: Boolean,
    incluir_produtos_combinados: Boolean,
  },
  data: () => ({
    listaDeProduto: [],
    timer: null,
    carregando_dados: false
  }),
  computed: {
    inputListeners: function () {
      const vm = this

      return Object.assign({},
        vm.$listeners, {
          input: function (values) {
            const valuesValidos = values ? values : ""
            vm.$emit('update:modelValue', valuesValidos)
          }
        }
      )
    }
  },
  watch: {
    fornecedores(atual, antigo) {
      if (atual && antigo && Array.isArray(atual) && Array.isArray(antigo) && atual.toString() === antigo.toString()) {
        return;
      }

      clearTimeout(this.timer)
      this.timer = setTimeout(() => this.buscarListaDeProdutos(), 1200)
    },
    forceBusca(atual) {
      if (atual) {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => this.buscarListaDeProdutos(), 1200)
      }
    }
  },
  mounted() {
    if (this.getAposMounted) {
      this.buscarListaDeProdutos()
    }
  },
  methods: {
    buscarProdutoAposDigitacao (ev) {
      if (!ev || !ev.target || [null, undefined].includes(ev.target.value)) return

      clearTimeout(this.timer)
      this.timer = setTimeout(() => this.buscarListaDeProdutos(ev.target.value), 1000)
    },
    buscarListaDeProdutos (pesquisa = '') {
      this.carregando_dados = true;

      const headers = this.Helpers.iniciarRequisicao();

      const itensJaSelecionados = Array.isArray(this.modelValue)
        ? this.listaDeProduto.filter(item => this.modelValue.includes(item.id_produto))
        : [];

      const params = {
        grupo: this.grupo,
        pesquisa,
        ignorar: this.ignorar_produtos.map(m => m.id_produto),
        fornecedores: this.fornecedores ? this.fornecedores : undefined,
        forcarBusca: (this.forceBusca.length > 0) ? this.forceBusca : undefined,
        incluir_produtos_combinados: this.incluir_produtos_combinados || false,
      };

      ProdutoAPI.getProdutosSobDemanda(headers, params)
        .then((response) => {
          const {token, produtos} = response.data;
          localStorage.setItem("token", token);

          const ignorar = this.ignorar_produtos;
          const produtos_filtrados = [...produtos.filter((obj) => !ignorar.some((filter_obj) => filter_obj.idproduto === obj.id_produto))];

          this.listaDeProduto = itensJaSelecionados.concat(produtos_filtrados);
          this.carregando_dados = false;
        })
        .catch(() => this.Helpers.logout());
    }
  }
}
</script>

<style scoped>
.text-gray-900 {
  color: #999;
}
</style>
